import Rest from "Utils/Rest";
import ClientLogsModel = NetHealth.EHR.Domain.UiModels.ClientLogsModel;

export default class LoggerService {

    postMessage(logsModel: ClientLogsModel) {
        return Rest.POST<void>('Logger/PostMessage', logsModel);
    }

}
